import { render, staticRenderFns } from "./respectScore2.vue?vue&type=template&id=3444e58d&scoped=true&"
import script from "./respectScore2.vue?vue&type=script&lang=js&"
export * from "./respectScore2.vue?vue&type=script&lang=js&"
import style0 from "./respectScore2.vue?vue&type=style&index=0&id=3444e58d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3444e58d",
  null
  
)

export default component.exports